import Vue from 'vue';
import Router from 'vue-router';

import SignIn from './views/SignIn';

import Dashboard from './views/Dashboard';

import Account from './views/Account';

import Admins from './views/Admins';
import Admin from './views/Admin';

import UnitOfMeasurement from './views/UnitOfMeasurement';

import TypeOfAgreement from './views/TypeOfAgreement';

import TypeOfCustomer from './views/TypeOfCustomer';

import Gender from './views/Gender';

import MaritalStatus from './views/MaritalStatus';

import Plots from './views/Plots';

import CategoryProduct from './views/CategoryProduct';
import Product from './views/Product';

import TypeOfMedicine from './views/TypeOfMedicine';
import TypeOfRecipe from './views/TypeOfRecipe';
import Medicine from './views/Medicine';

import Plans from './views/Plans';
import Plan from './views/Plan';

import Bank from './views/Bank';
import FeedingCare from './views/FeedingCare';

import Profiles from './views/Profiles';
import Profile from './views/Profile';

import Schedule from './views/Schedule';

import Contract from './views/Contract';

import PrescriptionCare from './views/PrescriptionCare';

import Modules from './views/Modules';
import Module from './views/Module';

import StatusRestHome from './views/StatusRestHome';

import RestHomes from './views/RestHomes';
import RestHome from './views/RestHome';

import Permissions from './views/Permissions';

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "signin",
            component: SignIn,
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
        },
        {
            path: "/errors",
            name: "errors",
            component: () => import('./views/Errors.vue'),
        },
        {
            path: "/account",
            name: "account",
            component: Account,
        },
        {
            path: "/admins",
            name: "admins",
            component: Admins,
        },
        {
            path: "/admin/:id",
            name: "admin",
            component: Admin,
        },
        {
            path: "/bank",
            name: "bank",
            component: Bank,
        },
        {
            path: "/feeding_care",
            name: "feeding_care",
            component: FeedingCare,
        },
        {
            path: "/profiles",
            name: "profiles",
            component: Profiles,
        },
        {
            path: "/profile/:id",
            name: "profile",
            component: Profile,
        },
        {
            path: "/plans",
            name: "plans",
            component: Plans,
        },
        {
            path: "/plan/:id",
            name: "plan",
            component: Plan,
        },
        {
            path: "/schedule",
            name: "schedule",
            component: Schedule,
        },
        {
            path: "/contract",
            name: "contract",
            component: Contract,
        },
        {
            path: "/prescription_care",
            name: "prescription_care",
            component: PrescriptionCare,
        },
        {
            path: "/modules",
            name: "modules",
            component: Modules,
        },
        {
            path: "/module/:id",
            name: "module",
            component: Module,
        },
        {
            path: "/status_rest_home",
            name: "status_rest_home",
            component: StatusRestHome,
        },
        {
            path: "/clients",
            name: "clients",
            component: RestHomes,
        },
        {
            path: "/client/:id",
            name: "client",
            component: RestHome,
        },
        {
            path: "/gender",
            name: "gender",
            component: Gender,
        },
        {
            path: "/professional-class-council",
            name: "professional-class-council",
            component: () => import('./views/ProfessionalClassCouncil'),
        },
        {
            path: "/unit_of_measurement",
            name: "unit_of_measurement",
            component: UnitOfMeasurement,
        },
        {
            path: "/type_of_agreement",
            name: "type_of_agreement",
            component: TypeOfAgreement,
        },
        {
            path: "/type_of_customer",
            name: "type_of_customer",
            component: TypeOfCustomer,
        },
        {
            path: "/marital_status",
            name: "marital_status",
            component: MaritalStatus,
        },
        {
            path: "/category_product",
            name: "category_product",
            component: CategoryProduct,
        },
        {
            path: "/product",
            name: "product",
            component: Product,
        },
        {
            path: "/type_of_medicine",
            name: "type_of_medicine",
            component: TypeOfMedicine,
        },
        {
            path: "/type_of_recipe",
            name: "type_of_recipe",
            component: TypeOfRecipe,
        },
        {
            path: "/medicine",
            name: "medicine",
            component: Medicine,
        },
        {
            path: "/plots",
            name: "plots",
            component: Plots,
        },
        {
            path: "/admin-permissions-management",
            name: "admin-permissions-management",
            component: () => import("./views/AdminPermissionsManagement"),
        },
        {
            path: "/permissions",
            name: "permissions",
            component: Permissions,
        },
        {
            path: "/rest-home-permissions",
            name: "rest-home-permissions",
            component: () => import("./views/RestHomePermissions"),
        },
        {
            path: "/rest-home-semiology-forms",
            name: "rest-home-semiology-forms",
            component: () => import("./views/RestHomeSemiologyForms"),
        },
        {
            path: "/rest-home-user-groups",
            name: "rest-home-user-groups",
            component: () => import("./views/RestHomeUserGroups"),
        },
        {
            path: "/rest-home-user-profiles",
            name: "rest-home-user-profiles",
            component: () => import("./views/RestHomeUserProfiles"),
        },
        {
            path: "/rest-home/units-of-measurement",
            name: "rest-home-units-of-measurement",
            component: () => import("./views/UnitsOfMeasurement"),
        },
        {
            path: "/settings",
            name: "settings",
            component: () => import('./views/Settings'),
        },
        {
            path: "/security-questions",
            name: "security-questions",
            component: () => import('./views/SecurityQuestions'),
        },
        {
            path: "/importers",
            name: "importers",
            component: () => import("./views/Importers"),
        },
        {
            path: "/static-routes",
            name: "static-routes",
            component: () => import("./views/StaticRoutes"),
        },
        {
            path: "/dynamic-routes",
            name: "dynamic-routes",
            component: () => import("./views/DynamicRoutes"),
        },
        {
            path: "/payment-terms",
            name: "payment-terms",
            component: () => import("./views/PaymentTerms"),
        },
        {
            path: "/route-of-administration",
            name: "route-of-administration",
            component: () => import("./views/RouteOfAdministration"),
        },
        {
            path: "/recurrence",
            name: "recurrence",
            component: () => import("./views/Recurrence"),
        },
        {
            path: '/print/charge/:rest_home_id/:charge_period',
            name: 'print-charge',
            component: () => import("./templates/print/Charge"),
        },
        {
            path: '/system-update',
            name: 'system-update',
            component: () => import("./views/SystemUpdate"),
        },
        {
            path: '/medicine-amount-of-times',
            name: 'medicine-amount-of-times',
            component: () => import("./views/MedicineAmountOfTimes"),
        },
        {
            path: '/branches',
            name: 'branches',
            component: () => import("./views/Branches"),
        },
        {
            path: '/branch/:id',
            name: 'branch',
            component: () => import("./views/Branch"),
        },
        {
            path: '/active-ingredient',
            name: 'active-ingredient',
            component: () => import("./views/ActiveIngredient"),
        },
        {
            path: '/billing-type-of-hosting-type',
            name: 'billing-type-of-hosting-type',
            component: () => import("./views/BillingTypeOfHostingType"),
        },
        {
            path: '/help',
            name: 'help',
            component: () => import("./views/Help"),
        },
        {
            path: '/certificate',
            name: 'certificate',
            component: () => import("./views/Certificate"),
        },
        {
            path: '/config-certificate',
            name: 'config_certificate',
            component: () => import("./views/ConfigCertificate"),
        },
        {
            path: '/rest-homes-print-charge/:ids/:year/:month/:charge_period',
            name: 'rest_homes_print_charge',
            component: () => import("./templates/print/Charges"),
        },
    ]
});

export default router;